<template>
  <div>
    <TrimEquipmentPage
      ref="page"
      :trim-id="id"
      :equipments="equipments"
      :selected-equipments="selectedEquipments"
    />

    <EquipmentBottomBar
      @save="save()"
      @cancel="cancel()"
    />
  </div>
</template>

<script>
import TrimEquipmentPage from "../../components/TrimEquipmentPage.vue";
import EquipmentBottomBar from "../../components/equipment/EquipmentBottomBar.vue";

export default {
  name: "TrimEquipment.vue",
  props: ["id", "equipments", "selectedEquipments"],
  components: {
    TrimEquipmentPage,
    EquipmentBottomBar,
  },
  methods: {
    save() {
      this.$refs.page.save().then(() => {
        document.getElementById("featuresBadge").innerHTML =
          this.$store.getters["trimEquipment/selectedEquipmentCount"];
      });;
    },
    cancel() {
      window.location.href = "/inventory/trims/" + this.id + "/edit";
    },
    toggleSelectionView() {
      this.$refs.page.toggleSelectionView();
    },
    unselectAllEquipment() {
      this.$refs.page.unselectAll();
      this.$refs.page.resetSelectionView();
    },
  },
};
</script>

